module.exports = __webpack_public_path__ + "img/wenskaarten-kerstkaarten-kerst-papette-quotes-2.b428d703.jpg";